export default __webpack_public_path__ + "static/media/payment-photo.0bea1a64.svg";